import React from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";
import dot from "dot-object"
import LearnMore_LightBox from "./LearnMore_LightBox";

class YesNo_NoDefault extends React.Component {
    static propTypes = {
        beanName: PropTypes.string,
        property: PropTypes.string,
        yesLabel: PropTypes.string,
        noLabel: PropTypes.string,
        questionKey: PropTypes.string,
        key: PropTypes.string,
        state: PropTypes.string,
        onYesClick: PropTypes.func,
        onNoClick: PropTypes.func,
        required: PropTypes.string,
        requireExplain: PropTypes.string,
        requireOptional: PropTypes.string,
        errorKey: PropTypes.string,
        personalisation: PropTypes.string,
        prProperty: PropTypes.string,
        prCondProperty: PropTypes.string,
        prCondKey: PropTypes.string,
        instructionText: PropTypes.string,
        instructionExplain: PropTypes.string,
        linkToPageID: PropTypes.string,
        controlInsideRepeater: PropTypes.string,
        repeaterShowHide: PropTypes.string,
        requireLightBox: PropTypes.string,
        pageid: PropTypes.string,
        questionAdditionalInstructions: PropTypes.string,
        imagePath: PropTypes.string,
        status: PropTypes.string
    }
    static defaultProps = {
        beanName: '',
        property: '',
        yesLabel: '',
        noLabel: '',
        questionKey: '',
        key: '',
        state: '',
        onYesClick: () => {
        },
        onNoClick: () => {
        },
        required: '',
        requireExplain: '',
        requireOptional: '',
        errorKey: '',
        personalisation: '',
        prProperty: '',
        prCondProperty: '',
        prCondKey: '',
        instructionText: '',
        instructionExplain: '',
        linkToPageID: '',
        controlInsideRepeater: '',
        repeaterShowHide: '',
        requireLightBox: '',
        pageid: '',
        questionAdditionalInstructions: '',
        imagePath: '',
        status: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            radioVal: "",
            showModal: false,
            application: {}
        }
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.application != prevState.application) {
            return {
                application: nextProps.application,
                radioVal: dot.pick(nextProps.property, nextProps.application.applicationData)
            }
        }
        return null;
    }

    render() {
        const {
            beanName, property, yesLabel, noLabel, questionKey, state, onYesClick, onNoClick,
            required, requireExplain, requireOptional, errorKey, instructionText, pageid, requireLightBox,
            status
        } = this.props;

        var dynamicId = beanName + "-" + property.replace(/\./g, '-');
        return (
            <div className="QuestionSection">
                {state == undefined || state == "" &&
                    <div>
                        <div className="Question">
                            {questionKey != "" &&
                                <div className="Question-title">
                                    <span className="Question-titleText">
                                        <FormatMessage id={questionKey}/>
                                        {requireOptional != "" &&
                                            <span className="requireOptional"><FormatMessage
                                                id="control.requireOptional"/>}</span>}
                                    </span>
                                    {requireLightBox != "" &&
                                        <a className="LearnMoreLink" onClick={() => this.handleShowModal()}>
                                            <FormatMessage id="control.explain"/>
                                        </a>
                                    }
                                </div>
                            }

                            {instructionText != "" &&
                                <div className="Question-instructions">
                                    <FormatMessage id={instructionText}/>
                                </div>
                            }
                        </div>

                        <div className="AnswerField set">
                            <div className="RadioList element">
                                <div className="RadioListItem">
                                    <div className="RadioInput">
                                        <input type="radio"
                                               name={dynamicId}
                                               value="1"
                                               onClick={onYesClick}
                                               id={dynamicId + "-yes"}
                                               className="RadioInput-input"
                                               checked={this.state.radioVal == "1"}
                                               onChange={(e) => this.handleRadioChange(property, "1")}
                                               data-msg-selectone={errorKey != "" ? errorKey : "error.control.common"}
                                               data-rule-selectone={required}/>
                                        <label className="RadioInput-label"
                                               htmlFor={dynamicId + "-yes"}>
                                            <FormatMessage id={yesLabel}/>
                                        </label>
                                    </div>
                                </div>
                                <div className="RadioListItem">
                                    <div className="RadioInput">
                                        <input type="radio"
                                               name={dynamicId}
                                               value="0"
                                               onClick={onNoClick}
                                               id={dynamicId + "-no"}
                                               className="RadioInput-input"
                                               checked={this.state.radioVal == "0"}
                                               onChange={(e) => this.handleRadioChange(property, "0")}
                                               data-msg-selectone={errorKey != "" ? errorKey : "error.control.common"}
                                               data-rule-selectone={required}/>
                                        <label className="RadioInput-label"
                                               htmlFor={dynamicId + "-no"}>
                                            <FormatMessage id={noLabel}/>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <p className="AnswerField-errorMessage"></p>
                        </div>
                    </div>
                }
                {this.state.showModal &&
                    <LearnMore_LightBox contentKey={"explainthis." + pageid}
                                        handleOpenModal={() => this.handleShowModal()}/>
                }
                {state != undefined && state == "output" &&
                    <div>
                        {!required ? <div className="ReviewSection-answerLabelOptional">
                                <FormatMessage id="message.optionfield"/>
                            </div> :
                            status == "incomplete" ?
                                <div className="ReviewAnswerStatus ReviewAnswerStatus-incomplete">
                                    <span className="ReviewAnswerStatus-label">
                                        <FormatMessage id="application.sectionreview.incomplete"/>
                                    </span>
                                </div> :
                                <div className="ReviewSection-answer">
                                    <span className="ReviewSection-answerLabel">
                                        {this.state.radioVal != undefined && this.state.radioVal == "1" ? "Yes" : "No"}
                                    </span>
                                </div>
                        }
                    </div>
                }
            </div>
        );
    }

    handleShowModal() {
        this.setState({
            showModal: !this.state.showModal
        })
    }

    handleRadioChange(property, value) {
        this.setState({
            radioVal: value
        })
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }
}

export default YesNo_NoDefault;
